/**
 * Ajuste la largeur de la popup quand l'iframe navigue vers /checkout (same-origin).
 */

const CHECKOUT_FRAME_CLASS = 'rtt-rb-popup-frame--checkout';

export function attachCheckoutFrameListener(
  iframe: HTMLIFrameElement,
  frame: HTMLElement
): () => void {
  const sync = (): void => {
    try {
      const path = iframe.contentWindow?.location.pathname ?? '';
      if (path === '/checkout' || path.startsWith('/checkout/')) {
        frame.classList.add(CHECKOUT_FRAME_CLASS);
      } else {
        frame.classList.remove(CHECKOUT_FRAME_CLASS);
      }
    } catch {
      /* cross-origin pendant redirect Stripe — on garde la classe checkout */
    }
  };

  iframe.addEventListener('load', sync);
  return () => {
    iframe.removeEventListener('load', sync);
    frame.classList.remove(CHECKOUT_FRAME_CLASS);
  };
}
